export const ERROR_MODIFY_STATUS = 'Erreur durant la modification du status';
export const STATUS_TO_DRAFT = 'Le status est passé en brouillon';
export const UNPUBLISH = 'Dépublier';
export const SEE_PUBLIC_SITE = 'Voir en front';
export const SEND_PUSH = 'Envoyer un push';
export const UNPUBLISH_VIDEO = 'Mettre en corbeille';
